// src/config/characterColorMap.ts

// 同样加上索引签名
const colorMap: Record<string, string> = {
  chika:    '#F4A32A',
  dia:      '#E02E2E',
  hanamaru: '#F9E500',
  kanan:    '#4EBEA6',
  mari:     '#9D45D9',
  riko:     '#F3C6C9',
  ruby:     '#FC84AF',
  yoshiko:  '#9CA3AF',
  you:      '#87E0F0',
  default:  '#CCCCCC',
};
export default colorMap;
